import React from "react";

import {
  ProgressBarWidgetDto,
  WidgetRenderLocation,
} from "@intelligems/ig-types";
import { IgProgressBar } from "@src/domains/WidgetLibrary/ProgressBar/IgProgressBar";
import { WidgetPreview } from "@src/domains/WidgetLibrary/WidgetPreview";
import { ProgressBarContextProvider } from "@src/features/personalizations/components/offerModifications/userInterfaces/progressBar/ProgressBarContextProvider";
import { CartValueInput } from "@src/features/personalizations/components/offerModifications/widgets/CartValueInput";
import { UserInterfaceWidgetPreview as Preview } from "@src/features/personalizations/components/offerModifications/widgets/UserInterfaceWidgetPreview";
import { useLibraryProgressBarConfig } from "@src/store/slices/widgets/selectors";

interface ProgressBarPreviewProps {
  mode: "toggle" | "input";
  isEdit?: boolean;
  widget: ProgressBarWidgetDto;
  widgetOverride?: ProgressBarWidgetDto;
  addWrapper?: boolean;
  hideLabel?: boolean;
  renderLocation?: WidgetRenderLocation;
}

export const ProgressBarPreview = ({
  widget,
  mode,
  isEdit,
  widgetOverride,
  hideLabel,
  renderLocation = "settings",
}: ProgressBarPreviewProps) => {
  const config = useLibraryProgressBarConfig(widget.id, widgetOverride);
  if (!widget || !config) return null;

  if (isEdit)
    return (
      <ProgressBarContextProvider config={config} mode={mode}>
        <Preview renderLocation={renderLocation}>
          {!hideLabel && (
            <Preview.Label label={"Preview"} renderLocation={renderLocation}>
              <CartValueInput size={"medium"} />
            </Preview.Label>
          )}
          <Preview.Widget device={"desktop"} renderLocation={renderLocation}>
            {config && <IgProgressBar device={"desktop"} config={config} />}
          </Preview.Widget>
        </Preview>
      </ProgressBarContextProvider>
    );

  return (
    <ProgressBarContextProvider config={config} mode={mode}>
      <WidgetPreview widget={widget}>
        <Preview.Widget device={"desktop"} renderLocation={renderLocation}>
          <IgProgressBar device={"desktop"} config={config} />
        </Preview.Widget>
      </WidgetPreview>
    </ProgressBarContextProvider>
  );
};
